import { ContainerModule, interfaces } from 'inversify';
import { ImportAnnotationsBl, ImportAnnotationsBlImpl } from './importAnnotations.bl';
import { ImportAnnotationsPermissions, ImportAnnotationsPermissionsImpl } from './importAnnotations.permissions';
import { IImportAnnotationsStore, ImportAnnotationsStoreImpl } from './importAnnotations.store';
import { IImportAnnotationsService, ImportAnnotationsService } from './services/ImportAnnotations.service';

export const importAnnotationsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IImportAnnotationsStore.$).to(ImportAnnotationsStoreImpl).inSingletonScope();
  bind(ImportAnnotationsBl.$).to(ImportAnnotationsBlImpl).inSingletonScope();
  bind(IImportAnnotationsService.$).to(ImportAnnotationsService).inSingletonScope();
  bind(ImportAnnotationsPermissions.$).to(ImportAnnotationsPermissionsImpl).inSingletonScope();
});
